<template>
  <div class="connect px">
    <div class="text">{{ text }}</div>
    <div
      class="rotating-circle px"
      :style="isLoading ? 'opacity: 1;' : 'opacity: 0;'"
    ></div>
    <div class="buttons" v-if="!isStart">
      <a class="button" :href="winUrl" download="AMasterDriverSetup.zip">
        <md-button>{{ $t("mouse.startAMMaster") }} (Windows)</md-button>
      </a>
      <a class="button" :href="macUrl" download="AMasterDriverSetup.zip">
        <md-button>{{ $t("mouse.startAMMaster") }} (Mac)</md-button>
      </a>
      <a class="button" @click="refresh">
        <md-button>
          {{ $t("refresh") }}
        </md-button>
      </a>
    </div>
    <div class="version-tip" v-if="!isStart">
      {{ $t("mouse.oldDriverTip") || "如遇连接异常，请下载最新版本 AMaster Driver" }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Modal } from "ant-design-vue";
import { download } from "@/utils";
import { DeviceWebSocket } from "@/utils/websocket";
import { deviceCallbackManager } from "@/utils/DeviceCallbackManager";

export default {
  data() {
    return {
      text: "",
      num: 0,
      port: 11223,
      isLoading: true,
      isStart: true,
      deviceWS: null,
      pollTimer: null, // 轮询定时器
    };
  },
  computed: {
    ...mapState("loader", {
      loading: "loading",
      systemInfo: "systemInfo",
    }),
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isTest: "isTest",
    }),
    winUrl() {
      return `https://angrymiao-www.oss-cn-shenzhen.aliyuncs.com/diy/AMasterDriverSetup${
        this.isTest ? "Test" : ""
      }.zip`;
    },
    macUrl() {
      return `https://angrymiao-www.oss-cn-shenzhen.aliyuncs.com/diy/AMasterDriverSetupMac${
        this.isTest ? "Test" : ""
      }.zip`;
    },
  },
  created() {},
  mounted() {
    this.$store.dispatch("loader/setIsWeb", true);
    deviceCallbackManager.subscribe("setSystemInfo", this.onHostSetSystemInfo);
    
    // 预加载 AM35 鼠标图片
    this.preloadAM35Images();
    
    const isChromeOrEdge =
      (/(Chrome\/\d+\.\d+\.\d+\.\d+|Edg\/\d+\.\d+\.\d+\.\d+)/.test(navigator.userAgent) &&
        navigator.vendor === "Google Inc.") ||
      /Edg/.test(navigator.userAgent);

    if (isChromeOrEdge || true) {
      this.$store.dispatch("loader/setInLoader", true);
      this.connectWS();
    } else {
      this.text = this.$t("mouse.browser");
    }
    if (window.location.href.includes("localhost")) {
      // window.testDeviceCallback.quickStartTest();
    }
  },
  beforeDestroy() {
    // 注意: 不取消订阅 setSystemInfo!
    // setSystemInfo 是全局事件,需要在整个应用生命周期保持订阅
    // 后续的配置页面(Mouse.vue, MouseAM35.vue)可能需要接收设备列表更新

    // 清理轮询定时器
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }

    // 注意: 不关闭 WebSocket 连接!
    // WebSocket 需要在整个应用生命周期中保持活跃,供后续的鼠标配置页面使用
    // 连接由 DeviceWebSocket 类管理,会在浏览器关闭或刷新时自动清理
  },
  methods: {
    // 预加载 AM35 鼠标图片
    preloadAM35Images() {
      const imageKeys = [
        'device_dongle',
        'mouse',
        'device_am35_b',
        'device_am35_a',
        'device_am35_m_b',
        'device_am35_m_a',
        'device_am35_d_b',
        'device_am35_d_a',
      ];
      
      imageKeys.forEach(key => {
        const src = this.images?.[key];
        if (src) {
          const img = new Image();
          img.src = src;
        }
      });
    },
    
    // 开始轮询获取系统信息
    startPollingSystemInfo() {
      // 清除旧的定时器
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
      }

      // 每秒轮询一次 getSystemInfo
      this.pollTimer = setInterval(() => {
        this.$store.dispatch("loader/getSystemInfo");

        // 检查是否获取到设备列表
        if (this.systemInfo.deviceList && this.systemInfo.deviceList.length > 0) {
          clearInterval(this.pollTimer);
          this.pollTimer = null;
          this.isLoading = false;

          // 跳转到设备列表页面
          this.$router.replace(this.$paths.deviceList);
        }
      }, 1000);
    },

    connectWS() {
      // 清理旧实例(防止组件重复实例化)
      if (window.__globalDeviceWS) {
        window.__globalDeviceWS.close();
        window.__globalDeviceWS = null;
      }
      this.deviceWS = null;

      // 初始化 UI
      this.isLoading = true;
      this.text = this.$t("mouse.connectAMMaster");

      // 创建 WebSocket
      this.deviceWS = new DeviceWebSocket(this.port, {
        reconnectPath: this.$paths.deviceConnect,
        offlineTimeout: 30000,
      });

      // 保存到全局
      window.__globalDeviceWS = this.deviceWS;

      // === 事件监听 ===

      // 连接成功
      this.deviceWS.on("connected", () => {
        this.text = this.$t("mouse.connectMouse");

        // 重连后恢复轮询
        if (this.$store.state.loader.bridge && !this.pollTimer) {
          this.startPollingSystemInfo();
        }
      });

      // 桥接初始化完成
      this.deviceWS.on("bridgeReady", (bridge) => {
        this.$store.dispatch("loader/setBridge", bridge);
        this.deviceWS.send("hello", "AM Master");
        this.startPollingSystemInfo();
      });

      // 监听 WebSocket 未连接时的调用
      this.deviceWS.on("notConnected", ({ method, redirectPath }) => {
        if (!window.location.href.includes("localhost")) {
          this.$router.replace(redirectPath);
        }
      });

      // 监听 hello 响应
      this.deviceWS.on("hello", (data) => {
        this.$store.dispatch("mouse/setVersion", {
          version: data === "web" ? "1.0.0" : data,
          isLatestVersion: data === "web" ? false : data >= "1.0.2",
        });

        if (data === "web") {
          // 版本过旧,提示更新
          this.$store.dispatch("loader/setLoading", false);
          Modal.destroyAll();
          this.$confirm({
            title: this.$t("loader.forceUpdate", ["AMasterDriver"]),
            okText: this.$t("loader.update"),
            cancelText: this.$t("cancel"),
            centered: true,
            onOk: () => {
              this.isStart = false;
              const isMac = navigator.platform.toUpperCase().includes("MAC");
              if (isMac) {
                this.onDownload(this.macUrl, "AMasterDriverSetupMac.zip");
              } else {
                this.onDownload(this.winUrl, "AMasterDriverSetup.zip");
              }
            },
          });
          return;
        }

        // 版本正常,继续轮询获取设备列表(在 startPollingSystemInfo 中处理)
      });

      // 监听 notFound 事件 - 设备未找到
      this.deviceWS.on("notFound", () => {
        this.text = this.$t("connect.text4") || "未找到设备";
        this.isLoading = false;
        Modal.confirm({
          title: this.$t("connect.title1") || "提示",
          content: this.$t("connect.content2") || "请下载并安装 AMaster Driver",
          centered: true,
          okText: this.$t("connect.okText2") || "下载驱动",
          cancelText: this.$t("connect.cancelText") || "重试",
          onOk: () => {
            this.isStart = false;
            const isMac = navigator.platform.toUpperCase().includes("MAC");
            if (isMac) {
              this.onDownload(this.macUrl, "AMasterDriverSetupMac.zip");
            } else {
              this.onDownload(this.winUrl, "AMasterDriverSetup.zip");
            }
          },
          onCancel: () => {
            this.connectWS();
          },
        });
      });

      // 监听设备断开
      this.deviceWS.on("disconnectMouse", () => {
        Modal.warning({
          title: this.$t("connect.title1") || "提示",
          content: this.$t("connect.content1") || "设备已断开连接",
          centered: true,
          okText: this.$t("connect.okText") || "确定",
          onOk: () => {
            this.$router.go(0);
          },
        });
      });

      // 连接关闭:停止轮询
      this.deviceWS.on("closed", () => {
        if (this.pollTimer) {
          clearInterval(this.pollTimer);
          this.pollTimer = null;
        }
      });

      // 错误处理
      this.deviceWS.on("error", (error) => {
        // console.error("WebSocket error:", error);
      });

      
      // 首次连接失败：尝试启动 Driver
      this.deviceWS.on("firstConnectionFailed", () => {
        console.log("First connection failed, attempting to launch AMaster Driver...");
        this.text = this.$t("mouse.connectAMMaster");
        this.isStart = false;
        
        // 启动 Driver
        window.location.href = "AMasterLauncher://";
      });

      // 达到最大重连次数
      this.deviceWS.on("maxReconnectReached", () => {
        this.text = this.$t("mouse.startAMMaster");
        this.isStart = false;

      });

      // 开始连接
      this.deviceWS.connect();
    },
    onDownload(file, fileName) {
      download(file, fileName);
      this.$store.dispatch("loader/setLoading", {
        loading: true,
        time: 60000,
      });
    },
    refresh() {
      window.location.reload();
    },
    onHostSetSystemInfo(json) {
      console.log("onHostSetSystemInfo", json);
      if (json) {
        try {
          const data = JSON.parse(json);
          this.$store.dispatch("loader/setSystemInfo", data);
        } catch (err) {
          console.error("DeviceConnect setSystemInfo: 解析失败", err);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.connect {
  width: 100%;
  height: 100vh;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .logo {
    width: 500px;
    height: auto;
    margin-bottom: 150px;
  }

  .text {
    width: 800px;
    font-size: 76px;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0;
    margin-bottom: 60px;
    margin-top: -30px;
    color: transparent;
    background: linear-gradient(270deg, #8743ff 0%, #4136f1 50%, #8743ff 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: scroll 1.5s linear infinite;
    display: inline;
  }

  .rotating-circle.px {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    position: relative;
    animation: rotate 2s linear infinite;
    transition: opacity 0.5s ease-in-out;
    background: conic-gradient(from 0deg, #8743ff, #4136f1, #8743ff);
    margin-bottom: 60px;
    padding: 10px;
  }

  .rotating-circle.px::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #171717;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(720deg);
    }
  }

  .buttons {
    @include flex-center;

    .button {
      background-color: $primary-color;
      border-radius: 5px;
      font-size: 24px;
      text-transform: none;
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .version-tip {
    margin-top: 30px;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
  }
}

@keyframes scroll {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 800px 0;
  }
}
</style>
